import { useCallback, useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Dropzone from './components/Dropzone';
import ConverterDashboard from './components/ConverterDashboard';
import Footer from './components/Footer';

function App() {
  const [darkMode, setDarkMode] = useState(
    () => globalThis.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
  );
  const [files, setFiles] = useState<File[]>([]);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
  }, [darkMode]);

  const addFiles = useCallback((newFiles: File[]) => {
    setFiles((prev) => {
      const existing = new Set(prev.map((f) => f.name + f.size));
      return [...prev, ...newFiles.filter((f) => !existing.has(f.name + f.size))];
    });
  }, []);

  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 transition-colors duration-300">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-bold focus:text-slate-900 focus:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 dark:focus:bg-slate-900 dark:focus:text-white">
        Skip to converter
      </a>

      <Header darkMode={darkMode} setDarkMode={setDarkMode} />

      <main id="main-content" className="flex-grow px-4 py-6 md:py-10">
        <Hero />
        <Dropzone onFilesAdded={addFiles} />
        <ConverterDashboard files={files} setFiles={setFiles} />
      </main>

      <Footer />
    </div>
  );
}

export default App;
